import script from "./FirstPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstPage.vue?vue&type=script&setup=true&lang=js"

import "./FirstPage.vue?vue&type=style&index=0&id=53036b5e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53036b5e"]])

export default __exports__